import React, { FC, useEffect } from 'react';
import { EveRoutes } from '@ver-uds/e-verify';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { SecureRoute } from '@vis-auth/react';
import { InternalRoutes } from './constants';
import SecurityProvider from './context/Security/SecurityProvider';
import Logout from './components/Logout';
import { useToggles } from './context/Toggles/TogglesContext';

import { MouRoutes } from './components/ClientMou/constants';
import MouRoute from './MouRoute';
import PublicRoute from './components/PublicRoute';
import EnrollmentRoute from './EnrollmentRoute';
import PageRoutes from './PageRoutes';
import EveEnroll from './pages/Enrollment/EveEnroll';
import EnrollmentValidateOTC from './pages/Enrollment/EnrollmentValidateOTC';

const OriginRedirect = ({ path }: { path: string }): null => {
  useEffect(() => {
    window.location.assign(path);
  });
  return null;
};

const AppRoute: FC = () => {
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
  }, []);

  const toggles = useToggles();

  const isMfaEnvironment = toggles?.get('MFA_USER_CREATION') === 'on';
  const isMaintenanceMode = toggles?.get('MAINTENANCE_MODE') === 'on';

  return (
    <Router>
      <SecurityProvider>
        {isMaintenanceMode && (
          <Route path="/">
            <OriginRedirect path="/maintenance" />
          </Route>
        )}

        <Route exact path={InternalRoutes.LOGOUT}>
          <Logout />
        </Route>
        <Switch>
          {/* Extracted into MouRoute.tsx for Dashboard JWT routing check */}
          <Route path={MouRoutes.BASE}>
            <MouRoute />
          </Route>
          {/* Extracted into EnrollmentRoute.tsx for Dashboard JWT routing check */}
          {/* Enrollment Routes for OTC validated MFA Enrollment */}
          <PublicRoute exact path={EveRoutes.ACCOUNT_ENROLL} conditionToShow={isMfaEnvironment}>
            <EveEnroll />
          </PublicRoute>
          {isMfaEnvironment && (
            <Route exact path={EveRoutes.ACCOUNT_ENROLL_VERIFY_OTC}>
              <EnrollmentValidateOTC />
            </Route>
          )}
          <Route path={EveRoutes.ACCOUNT_ENROLL_NEW}>
            <EnrollmentRoute />
          </Route>
          <SecureRoute path="/">
            <PageRoutes />
          </SecureRoute>
        </Switch>
      </SecurityProvider>
    </Router>
  );
};

export default AppRoute;
